<template>
  <div style="font-size: 16px;font-weight: 700; color:#ffffff;cursor: pointer;">
    注销账号
  </div>
</template>

<script>
  export default {
    name: "log-out",
    data(){
      return{

      }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/logOut/logOut.vue